export default {
  state: {
    conUser: {}
  },
  getters: {
    getConUser(state) {
      return conUser
    }
  },
  // mutations: {
  //   getConUser(state, data) {
  //     if(data&&data)
  //     state.conUser = data
      
  //   }
  // }
}


// WEBPACK FOOTER //
// ./src/store/appStore/index.js